<template>
  <div class="research-visits">
    <div class="research-visits-top">
        <div class="title">教研访问</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="research-visits-echarts">
        <div id="researchEchartsId" style="width: 100%;height: 100%"></div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'research-visits',
  data() {
    return {

    }
  },
  methods: {
    initEcharts(){
        let chartDom = document.getElementById('researchEchartsId');
        let myChart = echarts.init(chartDom);
        let option;

        option = {
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['集体备课', '听评课', '名师工作室'],
                selectedMode: false, // 是否允许点击
                top: '10px',
                left: '10px',
                textStyle: {
                    color: '#ffffff',
                    borderWidth: 2
                },
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                axisTick: {
                    alignWithLabel: true,
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#D6D6D6",
                    },
                },
            },
            yAxis: {
                type: 'value',
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: "#D6D6D6",
                    },
                },
                axisLabel: {
                    show: true,
                    verticalAlign: "middle",
                    textStyle: {
                        color: "#6EA0D3",
                    },
                },
                splitLine: {
                    show: false,
                },
            },
            color: ['#2B7FFF',"#27CDE6","#FF7642"],
            series: [
                {
                    name: '集体备课',
                    type: 'line',
                    stack: 'Total',
                    lineStyle:{
                        color:"#2B7FFF"
                    },
                    data: [120, 100, 101, 134, 90, 230, 400,210,245,654,542,513]
                },
                {
                    name: '听评课',
                    type: 'line',
                    stack: 'Total',
                    lineStyle:{
                        color:"#27CDE6"
                    },
                    data: [220, 182, 191, 234, 290, 330, 451,331,654,523,462,342]
                },
                {
                    name: '名师工作室',
                    type: 'line',
                    stack: 'Total',
                    lineStyle:{
                        color:"#FF7642"
                    },
                    data: [150, 90, 201, 154, 190, 330, 451,330,746,782,642,412]
                }
            ]
        };

        option && myChart.setOption(option);
    }
  },
  mounted(){
    this.initEcharts();
  }
}
</script>
<style lang='scss' scoped>
.research-visits{
    width: 100%;
    height: 350px;
    padding: 0 15px;
    // background: rgba(6,17,52,0.8);
    border: 1px solid #053882;
    position: relative;
    .research-visits-top{
        position: relative;
        text-align: center;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .research-visits-echarts{
        width: 100%;
        height: calc(100% - 40px);
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>